import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { CodesLayout, RefrencesLayout } from "../Layout";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    var currentUser = props.oidc.user;
        const handleCodesFormLoad = useCallback(() => {
        }, []);
        const handleRefrencesFormLoad = useCallback(() => {
    
        }, []);
    return (
            <TabPanel height={"auto"}>
                <TabItem title="Codes">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='85DFD7BD-D534-4F1E-9F50-CFFE612CF19E'
                        layoutName='LotUserDefinedCodeForm'
                        defaultFormSchema={CodesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={(name, value, e)=>props.handleFieldChange(name, value, e,formRefs)}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={()=>handleCodesFormLoad(formRefs)}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
                <TabItem title="References">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='D50D6ADB-D972-493C-B744-3137885E5200'
                        layoutName='LotUserDefinedRefForm'
                        defaultFormSchema={RefrencesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={(name, value, e)=>props.handleFieldChange(name, value, e,formRefs)}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={()=>handleRefrencesFormLoad(formRefs)}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
            </TabPanel>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedTab);